export default "__VITE_ASSET__7kUv3pu2__"